// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetCommissionResponse = App.Http.Responses.Commission.GetCommissionResponse;
import StoreCommissionRequest = App.Http.Requests.Commission.StoreCommissionRequest;
import UpdateCommissionRequest = App.Http.Requests.Commission.UpdateCommissionRequest;
import GetCommissionsRequest = App.Http.Requests.Commission.GetCommissionsRequest;
import GetCommissionsResponse = App.Http.Responses.Commission.GetCommissionsResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

class CommissionApi extends TenantBaseApi {
    async index(request: GetCommissionsRequest): Promise<GetCommissionsResponse> {
        return await this.get<GetCommissionsResponse, GetCommissionsRequest>("/commissions", {
            params: request,
        });
    }

    async show(commissionId: string, request?: unknown): Promise<GetCommissionResponse> {
        return await this.get<GetCommissionResponse, unknown>(`/commissions/${commissionId}`, {
            params: request,
        });
    }

    async store(request: StoreCommissionRequest): Promise<GetCommissionResponse> {
        return await this.post<GetCommissionResponse, StoreCommissionRequest>("/commissions", request);
    }

    async update(commissionId: string, request: UpdateCommissionRequest): Promise<GetCommissionResponse> {
        return await this.patch<GetCommissionResponse, UpdateCommissionRequest>(
            `/commissions/${commissionId}`,
            request
        );
    }

    async destroy(cascadeId: string): Promise<null> {
        return await this.delete<null, void>(`/commissions/${cascadeId}`);
    }

    async export(request: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>("/commissions/export", request);
    }
}

export const commissionApi = new CommissionApi();
